import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import CargoLoadPro from "@/pages/CargoLoadPro";
import ReportsPage from "@/pages/ReportsPage";
import SharedPlanPage from "@/pages/SharedPlanPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import useGoogleAnalytics from "@/hooks/useGoogleAnalytics";
import { AuthProvider } from "@/lib/auth";

// Extracted to a module constant so React doesn't re-diff this prop on every render.
const TOASTER_OPTIONS = {
  style: {
    background: "#0F172A",
    border: "1px solid rgba(255,255,255,0.08)",
    color: "#F8FAFC",
    borderRadius: "8px",
    fontFamily: "'IBM Plex Sans', sans-serif",
    boxShadow: "0 10px 30px -12px rgba(15,23,42,0.35)",
  },
};

// Router-aware wrapper so we can call the analytics hook inside <BrowserRouter>.
function AppRoutes() {
  useGoogleAnalytics();
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<CargoLoadPro />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/plan/:token" element={<SharedPlanPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Routes>
    </AuthProvider>
  );
}

function App() {
  return (
    <div className="App grain">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={TOASTER_OPTIONS}
      />
    </div>
  );
}

export default App;
